var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center",style:(`height:${_vm.height}`)},[_c('v-fade-transition',{attrs:{"leave-absolute":""}},[_c('div',{staticClass:"loading-icon"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }